import { ConceptNodeMap } from "../../Concepts.interface";
import { getAllDescendants } from "./getAllDescendants";
import { isAllChildrenSelected } from "./isAllChildrenSelected";

export const deselectNode = (
  id: string,
  selected: Set<string>,
  treeMap: ConceptNodeMap,
) => {
  const newSet = new Set(selected);

  newSet.delete(id);
  getAllDescendants(id, treeMap).forEach((desc) => newSet.delete(desc));

  let currentId = id;
  while (treeMap[currentId]?.parentId) {
    const parentId = treeMap[currentId]?.parentId as string;
    if (!isAllChildrenSelected(parentId, newSet, treeMap)) {
      newSet.delete(parentId);
    }
    currentId = parentId;
  }

  return newSet;
};
